import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Building, TrendingUp, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';

const tools = [
  {
    id: 'market-intelligence',
    title: 'Market Intelligence',
    description: 'AI sector analysis, earnings insights, and macro signals',
    icon: BarChart3,
    route: '/market-intelligence',
    color: 'hsl(var(--chart-1))',
  },
  {
    id: 'deal-analyzer',
    title: 'Deal Analyzer',
    description: 'Instant property analysis with ARV, rehab estimates, and investor scores',
    icon: Building,
    route: '/deal-analyzer',
    color: 'hsl(var(--chart-4))',
  },
];

export const InvestorToolsQuickAccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-background/30 backdrop-blur-sm border border-border/30 rounded-lg">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="flex items-center gap-3 mb-6"
      >
        <TrendingUp className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold text-foreground">Investor Tools</h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {tools.map((tool, index) => (
          <motion.div
            key={tool.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
          >
            <Card
              className="group cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg border border-border/50 bg-card/50 backdrop-blur-sm h-full"
              onClick={() => navigate(tool.route)}
            >
              <CardContent className="p-8 text-center h-full flex flex-col justify-center">
                <div className="mb-6">
                  <div
                    className="inline-flex p-4 rounded-2xl shadow-sm mx-auto"
                    style={{
                      backgroundColor: `${tool.color}15`,
                      border: `1px solid ${tool.color}30`,
                    }}
                  >
                    <tool.icon className="w-8 h-8" style={{ color: tool.color }} />
                  </div>
                </div>
                <div className="space-y-3">
                  <h3 className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
                    {tool.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {tool.description}
                  </p>
                </div>
                <div className="mt-4 flex items-center justify-center gap-1 text-xs text-muted-foreground group-hover:text-primary transition-colors">
                  <span>Open</span>
                  <ArrowRight className="w-3 h-3" />
                </div>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
